import React from 'react';
import { NavLink } from 'react-router-dom';

import WrappedForm from './SignInForm';

import './SignIn.scss';

const PageSignIn = () => {
  return (
    <>
      <div className='title-block'>
        <h5 className='form-title'>Giriş Ekranı</h5>
      </div>
      <WrappedForm />
    </>
  );
};

export default PageSignIn;
